import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Download from 'assets/icons/Download';
import LoadingCircle from 'assets/icons/LoadingCircle';

import { useTranslation } from 'react-i18next';
import { getShipmentOrder } from 'utils/network/http';
import i18n from 'i18next';
import { downloadPdf } from 'utils/functions';
import { sendEventToSegment } from 'utils/functions/Tracking';
import TRACKING_EVENTS from 'utils/constants/trackingEvents';

const DOC_LANG = {
  'en-GB': 'EN',
  'es-ES': 'ES',
  'fr-FR': 'FR',
  'pl-PL': 'PL',
  en_GB: 'EN',
  es_ES: 'ES',
  fr_FR: 'FR',
  pl_PL: 'PL',
  es: 'ES',
  fr: 'FR',
  en: 'EN',
  pl: 'PL'
};

const getCurrentLanguage = () => DOC_LANG[i18n.language] || 'EN';

const SimpleDocument = ({ title, journeyId }) => {
  const [loading, setLoading] = useState(false);
  const handleClick = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await getShipmentOrder(journeyId, getCurrentLanguage());
      downloadPdf(data, `order_${journeyId}`);
      sendEventToSegment(TRACKING_EVENTS.JOURNEY_ORDER_DOWNLOAD_REQUESTED, {
        journeyId
      });
    } catch (e) {
      console.error('Error getting document', e);
    } finally {
      setLoading(false);
    }
  }, [journeyId]);

  return (
    <div className="documentation__link documentation__link--simple">
      <span className="documentation__link-title">{title}</span>
      <button
        className="documentation__link-button"
        disabled={loading}
        onClick={handleClick}
        data-testid="documentation__link-button"
      >
        {!loading && <Download className="documentation__link-icon" />}
        {loading && (
          <LoadingCircle
            className="documentation__link-icon documentation__link-icon--loading"
            data-testid="documentation__loading-icon"
          />
        )}
      </button>
    </div>
  );
};

const Documentation = ({ className, journeyId, journeyStatus }) => {
  const { t } = useTranslation('Jobs');
  if (journeyStatus === 'DONE' || journeyStatus === 'CANCELLED') return null;
  return (
    <div className={className} data-testid="documentation">
      <div className="documentation">
        <div className="documentation__title">{t('documents')}</div>
        <div className="documentation__container">
          <SimpleDocument title={t('summaryOrder')} journeyId={journeyId} />
        </div>
      </div>
    </div>
  );
};

Documentation.propTypes = {
  className: PropTypes.string,
  journeyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  journeyStatus: PropTypes.string.isRequired
};
export default Documentation;
